<ohp-dialog *ngIf="showDialog"  (dismiss)="onDismiss()" [disableCloseLinkFocus]="true" [title]="inputDialogModel?.title" [componentArea]="inputDialogModel?.componentArea">
    <div ohpDialogActions>
        <input (ngModelChange)="onInputChange($event)" [ngClass]="{'error': inputText && !inputValidationResult.isValid }" (keydown)="handleInputKeyEvent($event)" #dialogInputField [placeholder]="inputDialogModel?.placeholder" [(ngModel)]="inputText" class="input-dialog-field">
        <div class="input-error" aria-hidden="true">
            {{ inputValidationResult?.message }}
        </div>
        <div>
            <!--Todo: Need to add Aria Label-->
            <button data-clicklog="custom"
                    [disabled]="!inputValidationResult.isValid"
                    [ngClass]="{'generic-button--disabled--grey': !inputValidationResult.isValid}"
                    class="input-dialog-button generic-button generic-button--bordered generic-button--fluent generic-button--fluent--primary ms-bgc-w-h ms-bgc-w-a ms-fcl-w ms-bgc-tp ms-fcl-tp-h ms-fcl-tp-a"
                    (click)="onClickInputTextButton()">
                <span class="generic-button__text">{{ inputDialogModel?.inputButtonModel?.text }}</span>
            </button>
        </div>
    </div>
</ohp-dialog>
